import React from 'react';
import { View,  Image, ImageBackground, Platform, Keyboard, StyleSheet, Dimensions } from 'react-native';
// import { isIos, deviceHeight } from './../Utils';
import { TextInput, Button, Snackbar, Surface } from 'react-native-paper';
// import Icon from "react-native-vector-icons/dist/Ionicons";
// import BackHandlerAndroid from './../AndroidBackHandler';
import { connect } from 'react-redux';
import { changePhoneNumber, clearChangePhoneNumber } from './../../store/action';
// import AdsScreen from './../Ads';
// import Toast, { DURATION } from 'react-native-easy-toast';
// import Colors from '../Colors';
// import LinearGradientComponent from './../HeaderBackgroundComponent';
// import StylesColors from './../Colors';
// import OfflineHandler from './../OfflineHandler';
import {Text, Styles} from "./../../components/UI-Components"
// import Icon from 'react-native-vector-icons/dist/Ionicons';
// const isIos = Platform.OS === "ios";
import Toaster from './../../components/snackBar_toaster';
import Header from "./../../components/Header";
import Container from '@material-ui/core/Container';

const { width, height } = Dimensions.get('window')

const logo = require('./../../assets/logo1.png')


class ChangePhoneNo extends React.Component {  

    state = {
        newPhoneNumber: '',
        phone: this.props.userDetails && this.props.userDetails.phone,
        newPhoneNumberErr: false,
        visible: false,
        snackbarMsg: '',
  
    };
   

    componentDidUpdate(prevProps) {
        if (prevProps.err !== this.props.err) {
            if (this.props.err) {
                const errMessage = this.props.errInfo || 'something went wrong...';
                this.showToaster(errMessage)
            }
        }
        if (prevProps.successMsg !== this.props.successMsg) {
            if (this.props.successMsg) {
                this.showToaster(this.props.successMsg)
                setTimeout(() => {
                    this.props.history.push('/verifyChangeNumber');
                }, 1000);
            }
        }
    }

    validatePhone = phone => {
        if (/^([0|\+[0-9]{1,5})?([6-9][0-9]{9})$/.test(phone)) return true;
        return false;
    }
   
    showToaster = (msg) => {
        this.setState({
            visible: true,
            snackbarMsg: msg
        })
      }
    changeNumber = () => {
        if (this.state.newPhoneNumber.length === 0 || this.state.newPhoneNumber.length !== 10 || !(this.validatePhone(this.state.newPhoneNumber))) {
            this.setState({
                newPhoneNumberErr: true,
            })
        } else {   
            this.setState({
                newPhoneNumberErr: false
            })         
            this.props.changePhoneNumber(this.state.newPhoneNumber);
        }
    }

    render() {
        // console.log(this.props, 'chagne phone');
        const { loading, successMsg } = this.props;
        const {
            newPhoneNumber,
            newPhoneNumberErr
        } = this.state;
        console.log(this.props.userDetails, "asd")
        return (
            <>
               <Header
                title="Change Number"
                headerRight
                headerRightClick={() => this.props.history.push('/Home')}
                />
                <div className='main-component' 
                    style={{display: 'flex', 
                    justifyContent: 'center',
                    alignItems: 'center'
                    }}
                >
                

                    <div style={{
                        flexDirection: 'column',
                        display: 'flex',
                        width: '80%',
                        padding: 25,
                        justifyContent: 'center',
                        alignItems: 'center',
                        }}
                    >
                
                    <View style={{ width: '100%',  backgroundColor: Styles.fiveMantraBgColor }}>

                    <View style={{  marginTop: -20, marginBottom: 20, alignItems: 'center'}}>

                    <Text style={{ color: '#222', fontSize: 40,  fontWeight: '600', marginTop: 15 }}>Change phone number </Text>
                    <View style={{ flexDirection: 'row', marginTop: 5 }}>
                        <Text style={{ color: '#999b9e', fontSize: 13, }}>
                            {/* OTP sent to  your mobile number or email */}
                           If you want to change your number you need to verify your new number
                        </Text>
                        {/* <Text style={{marginLeft:5,fontSize: 13,}}>{this.props.navigation.getParam('mobile')}</Text> */}
                    </View>`
                    </View>
                    
                        <View style={{ alignItems: 'center',}}>
                        </View>
                        <View style={{  marginHorizontal: 30, padding: 20,  }}>
                            
                            <View style={{
                            width:'98%',marginBottom:10
                            }}>
                            {/* <Icon
                                    style={{ fontSize: 18, position:'absolute',
                                    right:15,
                                    top:18, }}
                                    name={isIos ? "ios-phone-portrait" : "md-phone-portrait"}
                                    size={30} /> */}
                                <TextInput
                                    // style={{ boxShadow: '10 10 10 #ccc', backgroundColor: 'transparent', width: '90%' }}
                                    // type="outlined"
                                    mode="flat"
                                    style={[styles.inputBox, {color: Styles.primaryColor, fontSize: 18, fontWeight: 'bold', letterSpacing: 4}]}
                                    // keyboardType='numeric'
                                    label="Old phone number"
                                    onChangeText={text => this.setState({ text })}
                                    value={this.state.phone}
                                    editable={false}
                                    color={'##F5591F'}
                                    fontSize={2}
                                    theme={{ colors: { placeholder: '#A4A4A4', text: 'rgba(0,0,0,0.7)', primary: Styles.primaryColor, underlineColor: '#A4A4A4', } }}
                                    // theme={{ colors: { placeholder: '#F5591F', text: '#222', primary: '#F5591F', underlineColor: 'transparent', background: '#fff', fontSize: 12 } }}
                                />
                            </View>
                            <View style={{ marginLeft:2, marginTop:0,marginBottom:0, paddingRight: '2%' }}>
                                <Text style={{ color: "red", marginVertical: 2,fontSize:12, alignSelf: 'flex-end' }}>
                                    { newPhoneNumberErr && "Enter new phone number"}
                                </Text>
                            </View>
                            <View style={{
                                width:'98%'
                            }}>
                            {/* <Icon
                                    style={{ fontSize: 18, position:'absolute',
                                    right:15,
                                    top:18, }}
                                    name={isIos ? "ios-phone-portrait" : "md-phone-portrait"}
                                    size={30} /> */}
                                <TextInput
                                    mode="flat"
                                    style={[styles.inputBox, {color: Styles.primaryColor, fontSize: 18, fontWeight: 'bold', letterSpacing: 4}]}
                                    keyboardType='numeric'
                                    label="New phone number"
                                    onChangeText={newPhoneNumber => this.setState({ newPhoneNumber })}
                                    value={this.state.newPhoneNumber}
                                    error={this.state.newPhoneNumberErr}
                                    color={'#F5591F'}
                                    maxLength={10}
                                    fontSize={2}
                                    // theme={{ colors: { placeholder: '#F5591F', text: '#222', primary: '#F5591F', background: '#fff', fontSize: 10 } }}
                                    theme={{ colors: { placeholder: '#A4A4A4', text: 'rgba(0,0,0,0.7)', primary: Styles.primaryColor, underlineColor: '#A4A4A4', } }}
                                    onBlur={() => {
                                        (newPhoneNumber.length === 0 || !(this.validatePhone(newPhoneNumber)))
                                            ? this.setState({
                                                newPhoneNumberErr: true
                                            })
                                            : this.setState({
                                                newPhoneNumberErr: false
                                            })
                                    }}
                                />
                            </View> 
                            
                            <View style={{ marginTop: 18, marginHorizontal: 35, justifyContent: 'center', alignItems: 'center' }}>
                                <Button
                                    style={{ 
                                        width: 200,
                                        borderRadius: 10,
                                        marginTop: 20,
                                        backgroundColor: '#f9c741',
                                        // borderRadius: 15,
                                        borderWidth: 2,
                                        borderColor: '#fff',
                                       height: 50, 
                                       justifyContent: 'center',
                                       alignItems:'center',
                                        alignSelf : 'center' 
                                    }}
                                    mode="contained"
                                    disabled={loading || successMsg ? true : false}
                                    onPress={() => {
                                        // Keyboard.dismiss();
                                        setTimeout(() => {
                                            this.changeNumber()                                        
                                        }, 300);
                                    }}
                                    loading={loading ? true : false}
                                >
                                    SUBMIT
                        </Button>
                            </View>
                        </View>
                        {/* <Toast
                            position={Colors.toastPosition}
                            positionValue={Colors.toastPositionValue}
                            opacity={1}
                            textStyle={{ color: Colors.toastTextColor }}
                            style={{
                                marginBottom: 50,
                                backgroundColor: Colors.toastBgColor,
                                paddingHorizontal: Colors.toastPaddingHorizontal,
                                borderRadius: 20,
                            }}
                            ref="toast" /> */}
                            <Toaster 
                                show={this.state.showToast}
                                message={this.state.toasterMessage}
                            />

                    </View>
                    {/* ================ads screen ====================== */}
                    <View style={{}}>
                        <View style={{ position: 'absolute', bottom: 10, width: '100%', marginBottom: 0 }}>
                            {/* <AdsScreen screenName={'ChangePhoneNo'} /> */}
                        </View>
                    </View>
                    </div>
               
                </div>
            </>
        )
    }
}

const styles = StyleSheet.create({
    inputBox: {
        width: width <= 579 ? '100%' : '70%',
        backgroundColor: 'transparent',
        alignSelf: 'center'
      },
})
const mapStateToProps = state => {
    return (
        {
            userDetails: state.homeData && state.homeData.userDetails && state.homeData.userDetails && state.homeData.userDetails,
            loading: state.changePhoneNumber && state.changePhoneNumber.loading && state.changePhoneNumber.loading,
            err: state.changePhoneNumber && state.changePhoneNumber.error,
            errInfo: state.changePhoneNumber && state.changePhoneNumber.errorInfo && state.changePhoneNumber.errorInfo.data && (state.changePhoneNumber.errorInfo.data.message || state.changePhoneNumber.errorInfo.data.error),
            successMsg: state.changePhoneNumber.response && state.changePhoneNumber.response.success && state.changePhoneNumber.response.success
        }
        )
      
    }

export default connect(mapStateToProps, { changePhoneNumber, clearChangePhoneNumber })(ChangePhoneNo);